import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('dvgw2Validator', dvgw2Validator);

    /**
     * Validate DVGW2 Code
     * Taken from the JSF validator
     *
     * @author dadecker.btc
     * @ngInject
     */
    function dvgw2Validator($q, Registration, registerService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                function dvgw2Validator(ngModelValue) {
                    if (!ngModelValue || ngModelValue.length === 0) {
                        return true;
                    }

                    if (ngModelValue.length !== 13) {
                        return false;
                    }

                    var regExp = /^([0-9]){13}$/;
                    if (
                        !angular.isUndefined(attr.onlyNwpEic) &&
                        scope.$eval(attr.onlyNwpEic)
                    ) {
                        regExp = /[A-Z0-9]{2}[W-Z][A-Z-0-9]{13}$/;
                    }

                    return !!ngModelValue.match(regExp);
                }

                ctrl.$validators.dvgw2Validator = dvgw2Validator;
            }
        };
    }
})();
